module.exports = __webpack_public_path__ + "static/media/barcode-read-icon-form.41a2db25.svg";